import { render } from "./404.vue?vue&type=template&id=60f96f9c&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=60f96f9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60f96f9c"

export default script